<template>
  <div class="login-backend">
    <!-- 绑定 -->
    <div class="login-wrapper" v-if="userInfo == null">
      <h2 class="title">{{ title }}</h2>
      <el-input
        class="text-input"
        placeholder="请输入身份证号"
        v-model="form.userName"
        prefix-icon="el-icon-user-solid"
        clearable
      />
      <el-input
        class="text-input"
        placeholder="请输入密码"
        v-model="form.password"
        type="password"
        prefix-icon="el-icon-view"
      />
      <el-button type="danger" round class="login-button" @click="bind"
        >绑定</el-button
      >
      <div class="other-account"></div>
    </div>

    <!-- 解绑 -->
    <div class="userInfo" v-else>
      <el-card class="box-card-left">
        <div slot="header">
          <span>个人信息</span>
        </div>
        <div>
          <div class="text-center">
            <el-avatar :size="80"> {{ userInfo.fullName }} </el-avatar>
          </div>
          <ul class="list-group list-group-striped">
            <li class="list-group-item">
              <!-- <i class="el-icon-user-solid"/> -->
              账号
              <div class="pull-right">{{ userInfo.userName }}</div>
            </li>
          </ul>
        </div>
      </el-card>
      <div>
        <el-button type="danger" round class="unbind-button" @click="unbind"
          >解绑</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { bind, unbind, getGzhBindUser } from "@/api/user";
export default {
  name: "bind",
  data() {
    return {
      title: "赣州产控电子采购平台",
      form: {
        userName: "",
        password: "",
        code: "",
        openId: "",
      },
      loading: false,
      redirect: undefined,
      userInfo: {},
      rules: {
        userName: {
          required: true,
          trigger: "blur",
          message: "请输入身份证号",
        },
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    // 获取url路径参数
    this.getUrlParam("code");
    // 判断是否已绑定
    this.getGzhBindUser();
  },

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },

  methods: {
    // 绑定
    bind() {
      // 这里是需要请求后台进行验证，然后根据结果是否登陆成功。
      var data = {
        userName: this.form.userName.trim(),
        password: this.form.password,
        openId: this.openId,
      };
      console.log(data);
      bind(data).then((response) => {
        console.log(response);
        if (response.code == 200) {
          this.reset();
          this.$message({
            message: "绑定成功",
            type: "success",
          });
        }
      });
    },

    // 解绑
    unbind() {
      var data = {
        openId: this.openId,
        uuid: this.userInfo.uuid
      };
      unbind(data).then((response) => {
        console.log(response);
        if (response.code == 200) {
          this.userInfo = null;
          this.$message({
            message: "解绑成功",
            type: "success",
          });
        }
      });
    },

    // 获取url路径参数
    getUrlParam(name) {
      let u = window.location.href,
        reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        r = u.substr(u.indexOf("?") + 1).match(reg);
      var code = r != null ? decodeURI(r[2]) : "";
      this.code = code;
      console.log(window.location.href, this.code);
    },

    // 获取公众号openid绑定用户
    getGzhBindUser() {
      this.userInfo = null;
      var query = { 
        code: this.code, 
      };
      getGzhBindUser(query).then((res) => {
        console.log(res);
        if(res.code == 200 && res.data != null){
          this.userInfo = res.data.user;
          this.openId = res.data.openId;
        }   
      });
    },

    // 表单重置
    reset() {
      this.form = {
        userName: "",
        password: "",
        code: "",
        openId: "",
      };
    },
  }, //methods end
};
</script>

<style scoped lang="less">
#app {
  min-width: none;
}

.userInfo {
  width: 400px;
  height: 300px;
  padding: 30px;
  margin-top: -120px;
}

.unbind-button {
  margin-top: 30px;
  width: 100%;
}

.el-card__header {
  padding: 14px 15px 7px;
  min-height: 40px;
}

.el-card__body {
  padding: 15px 20px 20px 20px;
}

.text-center {
  text-align: center;
  padding-bottom: 16px;
}

.el-avatar {
  background: @main-color;
}

.list-group {
  padding-left: 0px;
  list-style: none;
}

.list-group-striped > .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.list-group-item {
  border-bottom: 1px solid #e7eaec;
  border-top: 1px solid #e7eaec;
  margin-bottom: -1px;
  padding: 11px 0px;
  font-size: 13px;
}

.list-group-block {
  padding: 20px 0px;
}

.pull-right {
  float: right !important;
}

.login-backend {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 120px;
  .login-wrapper {
    width: 400px;
    height: 360px;
    padding: 12px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 12px;
    }
    .login-button {
      margin-top: 30px;
      width: 100%;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .other-account {
      .account-icon {
        width: 60px;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
  }
}
</style>
